import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const DEFAULT_TITLE = "WarUrna — WarEra election forecasts";

/** Set the document title once page data is in (pass null while loading).
 * The server rewrites <title> per entity on full document loads (see
 * worker/lib/og.ts); this keeps SPA transitions in sync — App resets to the
 * default on every route change (in a layout effect, which flushes before
 * this passive one), then pages override via this hook. `pathname` is a dep
 * so a param-only navigation (same component, same title) re-applies after
 * the reset. */
export function usePageTitle(title: string | null) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = `${title} — WarUrna`;
  }, [title, pathname]);
}
